import { render, staticRenderFns } from "./LolitaTreasure.vue?vue&type=template&id=f0daa13a&scoped=true&"
import script from "./LolitaTreasure.vue?vue&type=script&lang=js&"
export * from "./LolitaTreasure.vue?vue&type=script&lang=js&"
import style0 from "./LolitaTreasure.vue?vue&type=style&index=0&id=f0daa13a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0daa13a",
  null
  
)

export default component.exports